export class ContactPerson {
  title: string;
  firstName: string;
  lastName: string;
  position: string;
  email: string;
  phoneNr: string;
  mobileNr: string;
  lang: string;
  getsOffer: boolean;

  constructor () {
    this.title = 'MR';
    this.firstName = '';
    this.lastName = '';
    this.position = '';
    this.email = '';
    this.phoneNr = '';
    this.mobileNr = '';
    this.lang = 'DE';
    this.getsOffer = false;
  }
}



// WEBPACK FOOTER //
// ./src/models/contactPerson.ts